module.exports = __webpack_public_path__ + "static/media/BICI_ALT.9b4c09cc.svg";